import XocsCore from 'react-xocs/dist/xocs-core';
import { skip, node, nodeWithId } from 'react-xocs/dist/xocs/xocs-core';
import articleNumber from 'react-xocs/dist/xocs/references/article-number';
import reference from 'react-xocs/dist/xocs/references/reference';
import otherRef from 'react-xocs/dist/xocs/references/other-ref';
import para from 'react-xocs/dist/xocs/para';
import doi from 'react-xocs/dist/xocs/references/doi';
import math from 'react-xocs/dist/math/';
import interRef from '../inter-ref';
import sectionTitle from '../section-title';
import referenceLink from './referenceLink';
import contribution from './contribution';

const label = node('dt', { className: 'label' });

const components = {
  'article-number': articleNumber,
  reference,
  'inter-ref': interRef,
  'section-title': sectionTitle,
  math,
  para,
  'simple-para': para,
  'note-para': para,
  'cross-ref': skip,
  collaboration: skip,
  'other-ref': otherRef,
  label,
  anchor: nodeWithId('span'),
  doi,
};

const overrides = {
  label, referenceLink, contribution,
};

function getRefLink(content) {
  const refLink = content.$$.find(e => e['#name'] === 'referenceLink');
  if (refLink) {
    return refLink.$;
  }
  return null;
}

export default function Reference(content) {
  const refLink = getRefLink(content);
  const { assetCdnUrl } = window.config;
  const variables = { refLink, assetCdnUrl };
  return (
    <dl key={0}>
      {XocsCore({
        content, components, overrides, variables,
      })}
    </dl>
  );
}
